import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const brokerageApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getBrokerageDashboardOverview: build.query({
            query: (params) => {
                // params: { tab, start_date?, end_date? }
                const queryString = serialize(params);
                return {
                    url: `/brokerage-data/dashboard-overview?${queryString}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['brokerageDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
    }),
});

export const { useGetBrokerageDashboardOverviewQuery } = brokerageApi;
